<a *ngIf="btnWhatsApp" id="btn-close-modal" class="btn-primary btn-close" href="{{ urlMessage }}" target="_blank">
  Habla con Nosotros</a
>
